import { z } from 'zod'
import { lista, uuidDeRota } from './comum.js'

/** A fila única para onde vão jobs que esgotaram as tentativas (spec 01 §10). */
export const FILA_MORTA = 'dv-fila-morta'

/**
 * O endpoint não devolve o payload do job: ele pode conter dado de cliente.
 * Para operar a falha bastam a origem, a idade, as tentativas e a mensagem segura.
 */
export const jobMorto = z.object({
  id: uuidDeRota,
  filaOrigem: z.string(),
  jobIdOrigem: uuidDeRota.nullable(),
  criadoEm: z.string(),
  movidoEm: z.string(),
  tentativas: z.number().int().nonnegative(),
  erro: z.string().nullable(),
})
export type JobMorto = z.infer<typeof jobMorto>

/**
 * `de`/`ate` recortam por `movidoEm` — a data em que a falha entrou na fila de
 * mortos, e não a de criação do job original.
 *
 * A distinção importa quando a fila cresce: um job criado em junho que só esgotou
 * as tentativas em agosto é uma falha de AGOSTO para quem opera a bandeja, e
 * filtrar pela criação o esconderia da janela em que ele apareceu. As datas são
 * recorte (spec 05 §11): valor malformado é ignorado pelo controlador, não é 400.
 */
export const buscaDeJobsMortos = z.object({
  de: z.string().optional(),
  ate: z.string().optional(),
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(50),
})
export type BuscaDeJobsMortos = z.infer<typeof buscaDeJobsMortos>

export const respostaDeJobsMortos = lista(jobMorto)
export type RespostaDeJobsMortos = z.infer<typeof respostaDeJobsMortos>
